module.exports = __webpack_public_path__ + "img/wecook-logo-big.72962c8f.svg";